/*!
 * Deco Arts — Cookie Consent Manager v1.0.0
 * Custom CMP — CNIL/GDPR compliant, Google Consent Mode v2, Shopify Customer Privacy API bridge
 * Auto-blocking pattern (Tarteaucitron-style) + Cookiebot-inspired UX
 * License: MIT — © Linens Diffusion
 *
 * Usage in theme.liquid <head> (BEFORE any tracking script):
 *   {% render 'cookie-consent-init' %}
 */
(function (w, d) {
  "use strict";

  /* ============ Configuration defaults ============ */
  var DEFAULTS = {
    cookieName: "cc_decoarts_v1",
    cookieMaxAgeDays: 395,            // 13 months — CNIL maximum
    cookieDomain: "",                 // auto-detect
    cookieSameSite: "Lax",
    locale: "fr",
    fallbackLocale: "fr",
    privacyPolicyUrl: "/policies/privacy-policy",
    cookiePolicyUrl: "/pages/cookies",
    showTrigger: true,                // floating "manage cookies" button
    blockAutoOnLoad: true,            // auto-block trackers on init
    googleConsentDefault: "denied",   // initial Consent Mode v2 default
    shopName: "Deco Arts",
    shopLogoUrl: ""
  };

  /* ============ Translations ============ */
  var I18N = {
    fr: {
      title: "Vos préférences cookies",
      subtitle: "Confidentialité Deco Arts",
      intro: 'Nous utilisons des cookies pour améliorer votre expérience, analyser notre trafic, et vous proposer du contenu adapté. Certains cookies sont nécessaires au fonctionnement du site, d\'autres sont optionnels et requièrent votre accord.',
      learnMore: 'En savoir plus dans notre <a href="{policy}">politique de confidentialité</a>.',
      tab_consent: "Consentement",
      tab_details: "Détails",
      tab_about: "À propos",
      detailsIntro: "Activez ou désactivez chaque catégorie selon vos préférences. Les cookies nécessaires ne peuvent pas être désactivés.",
      aboutTitle: "À propos des cookies",
      aboutText: 'Les cookies sont de petits fichiers texte stockés sur votre appareil par les sites que vous visitez. Ils permettent au site de mémoriser vos préférences (langue, devise, panier) et d\'analyser son utilisation.<br><br>Vous pouvez modifier vos choix à tout moment via le bouton flottant "Gérer mes cookies" en bas à gauche de chaque page, ou consulter notre <a href="{cookies}">déclaration cookies complète</a>.',
      btn_accept: "Tout accepter",
      btn_reject: "Tout refuser",
      btn_save: "Enregistrer mes choix",
      btn_customize: "Personnaliser",
      btn_close: "Fermer",
      btn_show_details: "Voir les détails",
      meta: "Conforme RGPD & CNIL — Vos choix sont conservés 13 mois.",
      trigger_aria: "Gérer mes préférences cookies",
      trigger_label: "Gérer les cookies",
      cat_necessary_name: "Strictement nécessaires",
      cat_necessary_desc: "Indispensables au fonctionnement du site (panier, session, sécurité, langue). Sans ces cookies, le site ne peut pas fonctionner correctement.",
      cat_necessary_required: "Toujours actifs",
      cat_preferences_name: "Préférences",
      cat_preferences_desc: "Mémorisent vos choix (langue, devise, source de visite) pour personnaliser votre expérience lors de visites ultérieures.",
      cat_statistics_name: "Statistiques",
      cat_statistics_desc: "Nous aident à comprendre comment les visiteurs utilisent le site (pages visitées, durée de session) pour l'améliorer. Données anonymisées.",
      cat_marketing_name: "Marketing",
      cat_marketing_desc: "Permettent de mesurer l'efficacité de nos campagnes publicitaires et de vous proposer des publicités personnalisées sur d'autres sites (Facebook, Instagram, TikTok, Pinterest, Google).",
      services_label: "Services concernés"
    },
    en: {
      title: "Your cookie preferences",
      subtitle: "Deco Arts Privacy",
      intro: 'We use cookies to improve your experience, analyze our traffic, and deliver tailored content. Some cookies are essential to the site\'s operation, others are optional and require your consent.',
      learnMore: 'Learn more in our <a href="{policy}">privacy policy</a>.',
      tab_consent: "Consent",
      tab_details: "Details",
      tab_about: "About",
      detailsIntro: "Toggle each category according to your preferences. Strictly necessary cookies cannot be disabled.",
      aboutTitle: "About cookies",
      aboutText: 'Cookies are small text files stored on your device by websites you visit. They allow the site to remember your preferences (language, currency, cart) and analyze its usage.<br><br>You can change your choices at any time via the floating "Manage cookies" button at the bottom left of each page, or consult our <a href="{cookies}">full cookie declaration</a>.',
      btn_accept: "Accept all",
      btn_reject: "Reject all",
      btn_save: "Save my choices",
      btn_customize: "Customize",
      btn_close: "Close",
      btn_show_details: "Show details",
      meta: "GDPR & CNIL compliant — Your choices are kept for 13 months.",
      trigger_aria: "Manage cookie preferences",
      trigger_label: "Manage cookies",
      cat_necessary_name: "Strictly necessary",
      cat_necessary_desc: "Essential for the site to operate (cart, session, security, language). Without these cookies, the site cannot function properly.",
      cat_necessary_required: "Always active",
      cat_preferences_name: "Preferences",
      cat_preferences_desc: "Remember your choices (language, currency, visit source) to personalize your experience on future visits.",
      cat_statistics_name: "Statistics",
      cat_statistics_desc: "Help us understand how visitors use the site (pages viewed, session duration) to improve it. Anonymized data.",
      cat_marketing_name: "Marketing",
      cat_marketing_desc: "Measure the effectiveness of our advertising campaigns and deliver personalized ads on other sites (Facebook, Instagram, TikTok, Pinterest, Google).",
      services_label: "Services involved"
    },
    de: {
      title: "Ihre Cookie-Einstellungen",
      subtitle: "Deco Arts Datenschutz",
      intro: 'Wir verwenden Cookies, um Ihre Erfahrung zu verbessern, unseren Traffic zu analysieren und maßgeschneiderte Inhalte bereitzustellen. Einige Cookies sind für den Betrieb der Website unerlässlich, andere sind optional und erfordern Ihre Zustimmung.',
      learnMore: 'Mehr erfahren in unserer <a href="{policy}">Datenschutzerklärung</a>.',
      tab_consent: "Zustimmung",
      tab_details: "Details",
      tab_about: "Über",
      detailsIntro: "Aktivieren oder deaktivieren Sie jede Kategorie nach Ihren Wünschen. Notwendige Cookies können nicht deaktiviert werden.",
      aboutTitle: "Über Cookies",
      aboutText: 'Cookies sind kleine Textdateien, die von besuchten Websites auf Ihrem Gerät gespeichert werden. Sie ermöglichen es der Website, Ihre Einstellungen (Sprache, Währung, Warenkorb) zu merken und die Nutzung zu analysieren.<br><br>Sie können Ihre Auswahl jederzeit über die schwebende Schaltfläche "Cookies verwalten" unten links auf jeder Seite ändern oder unsere <a href="{cookies}">vollständige Cookie-Erklärung</a> einsehen.',
      btn_accept: "Alle akzeptieren",
      btn_reject: "Alle ablehnen",
      btn_save: "Auswahl speichern",
      btn_customize: "Anpassen",
      btn_close: "Schließen",
      btn_show_details: "Details anzeigen",
      meta: "DSGVO-konform — Ihre Auswahl wird 13 Monate gespeichert.",
      trigger_aria: "Cookie-Einstellungen verwalten",
      trigger_label: "Cookies verwalten",
      cat_necessary_name: "Notwendig",
      cat_necessary_desc: "Für den Betrieb der Website unerlässlich (Warenkorb, Sitzung, Sicherheit, Sprache). Ohne diese Cookies kann die Website nicht ordnungsgemäß funktionieren.",
      cat_necessary_required: "Immer aktiv",
      cat_preferences_name: "Präferenzen",
      cat_preferences_desc: "Speichern Ihre Auswahl (Sprache, Währung, Besuchsquelle), um Ihre Erfahrung bei zukünftigen Besuchen zu personalisieren.",
      cat_statistics_name: "Statistiken",
      cat_statistics_desc: "Helfen uns zu verstehen, wie Besucher die Website nutzen (besuchte Seiten, Sitzungsdauer), um sie zu verbessern. Anonymisierte Daten.",
      cat_marketing_name: "Marketing",
      cat_marketing_desc: "Messen die Wirksamkeit unserer Werbekampagnen und liefern personalisierte Anzeigen auf anderen Websites (Facebook, Instagram, TikTok, Pinterest, Google).",
      services_label: "Betroffene Dienste"
    },
    es: {
      title: "Tus preferencias de cookies",
      subtitle: "Privacidad Deco Arts",
      intro: 'Utilizamos cookies para mejorar tu experiencia, analizar nuestro tráfico y ofrecerte contenido personalizado. Algunas cookies son necesarias para el funcionamiento del sitio, otras son opcionales y requieren tu consentimiento.',
      learnMore: 'Más información en nuestra <a href="{policy}">política de privacidad</a>.',
      tab_consent: "Consentimiento",
      tab_details: "Detalles",
      tab_about: "Acerca de",
      detailsIntro: "Activa o desactiva cada categoría según tus preferencias. Las cookies necesarias no se pueden desactivar.",
      aboutTitle: "Acerca de las cookies",
      aboutText: 'Las cookies son pequeños archivos de texto almacenados en tu dispositivo por los sitios que visitas. Permiten que el sitio recuerde tus preferencias (idioma, moneda, carrito) y analice su uso.<br><br>Puedes modificar tus elecciones en cualquier momento mediante el botón flotante "Gestionar cookies" en la parte inferior izquierda de cada página, o consultar nuestra <a href="{cookies}">declaración de cookies completa</a>.',
      btn_accept: "Aceptar todo",
      btn_reject: "Rechazar todo",
      btn_save: "Guardar mis elecciones",
      btn_customize: "Personalizar",
      btn_close: "Cerrar",
      btn_show_details: "Ver detalles",
      meta: "Conforme con RGPD y CNIL — Tus elecciones se conservan 13 meses.",
      trigger_aria: "Gestionar mis preferencias de cookies",
      trigger_label: "Gestionar cookies",
      cat_necessary_name: "Estrictamente necesarias",
      cat_necessary_desc: "Esenciales para el funcionamiento del sitio (carrito, sesión, seguridad, idioma). Sin estas cookies, el sitio no puede funcionar correctamente.",
      cat_necessary_required: "Siempre activas",
      cat_preferences_name: "Preferencias",
      cat_preferences_desc: "Recuerdan tus elecciones (idioma, moneda, fuente de visita) para personalizar tu experiencia en futuras visitas.",
      cat_statistics_name: "Estadísticas",
      cat_statistics_desc: "Nos ayudan a entender cómo los visitantes utilizan el sitio (páginas vistas, duración de sesión) para mejorarlo. Datos anonimizados.",
      cat_marketing_name: "Marketing",
      cat_marketing_desc: "Permiten medir la eficacia de nuestras campañas publicitarias y ofrecerte anuncios personalizados en otros sitios (Facebook, Instagram, TikTok, Pinterest, Google).",
      services_label: "Servicios involucrados"
    },
    it: {
      title: "Le tue preferenze sui cookie",
      subtitle: "Privacy Deco Arts",
      intro: 'Utilizziamo cookie per migliorare la tua esperienza, analizzare il nostro traffico e offrirti contenuti personalizzati. Alcuni cookie sono necessari al funzionamento del sito, altri sono facoltativi e richiedono il tuo consenso.',
      learnMore: 'Scopri di più nella nostra <a href="{policy}">informativa sulla privacy</a>.',
      tab_consent: "Consenso",
      tab_details: "Dettagli",
      tab_about: "Informazioni",
      detailsIntro: "Attiva o disattiva ogni categoria in base alle tue preferenze. I cookie necessari non possono essere disattivati.",
      aboutTitle: "Informazioni sui cookie",
      aboutText: 'I cookie sono piccoli file di testo memorizzati sul tuo dispositivo dai siti che visiti. Consentono al sito di ricordare le tue preferenze (lingua, valuta, carrello) e di analizzarne l\'utilizzo.<br><br>Puoi modificare le tue scelte in qualsiasi momento tramite il pulsante "Gestisci cookie" in basso a sinistra di ogni pagina, o consultare la nostra <a href="{cookies}">dichiarazione completa sui cookie</a>.',
      btn_accept: "Accetta tutto",
      btn_reject: "Rifiuta tutto",
      btn_save: "Salva le mie scelte",
      btn_customize: "Personalizza",
      btn_close: "Chiudi",
      btn_show_details: "Mostra dettagli",
      meta: "Conforme GDPR & CNIL — Le tue scelte sono conservate per 13 mesi.",
      trigger_aria: "Gestisci le mie preferenze sui cookie",
      trigger_label: "Gestisci cookie",
      cat_necessary_name: "Strettamente necessari",
      cat_necessary_desc: "Essenziali per il funzionamento del sito (carrello, sessione, sicurezza, lingua). Senza questi cookie, il sito non può funzionare correttamente.",
      cat_necessary_required: "Sempre attivi",
      cat_preferences_name: "Preferenze",
      cat_preferences_desc: "Ricordano le tue scelte (lingua, valuta, sorgente di visita) per personalizzare la tua esperienza nelle visite future.",
      cat_statistics_name: "Statistiche",
      cat_statistics_desc: "Ci aiutano a capire come i visitatori utilizzano il sito (pagine visitate, durata della sessione) per migliorarlo. Dati anonimizzati.",
      cat_marketing_name: "Marketing",
      cat_marketing_desc: "Permettono di misurare l'efficacia delle nostre campagne pubblicitarie e di offrirti annunci personalizzati su altri siti (Facebook, Instagram, TikTok, Pinterest, Google).",
      services_label: "Servizi coinvolti"
    },
    nl: {
      title: "Uw cookievoorkeuren",
      subtitle: "Deco Arts Privacy",
      intro: 'We gebruiken cookies om uw ervaring te verbeteren, ons verkeer te analyseren en op maat gemaakte inhoud te leveren. Sommige cookies zijn essentieel voor de werking van de site, andere zijn optioneel en vereisen uw toestemming.',
      learnMore: 'Lees meer in ons <a href="{policy}">privacybeleid</a>.',
      tab_consent: "Toestemming",
      tab_details: "Details",
      tab_about: "Over",
      detailsIntro: "Schakel elke categorie in of uit volgens uw voorkeuren. Noodzakelijke cookies kunnen niet worden uitgeschakeld.",
      aboutTitle: "Over cookies",
      aboutText: 'Cookies zijn kleine tekstbestanden die door websites die u bezoekt op uw apparaat worden opgeslagen. Ze stellen de site in staat uw voorkeuren te onthouden (taal, valuta, winkelwagen) en het gebruik te analyseren.<br><br>U kunt uw keuzes op elk moment wijzigen via de zwevende knop "Cookies beheren" linksonder op elke pagina, of onze <a href="{cookies}">volledige cookieverklaring</a> raadplegen.',
      btn_accept: "Alles accepteren",
      btn_reject: "Alles weigeren",
      btn_save: "Mijn keuzes opslaan",
      btn_customize: "Aanpassen",
      btn_close: "Sluiten",
      btn_show_details: "Details bekijken",
      meta: "AVG-conform — Uw keuzes worden 13 maanden bewaard.",
      trigger_aria: "Cookievoorkeuren beheren",
      trigger_label: "Cookies beheren",
      cat_necessary_name: "Strikt noodzakelijk",
      cat_necessary_desc: "Essentieel voor de werking van de site (winkelwagen, sessie, beveiliging, taal). Zonder deze cookies kan de site niet goed functioneren.",
      cat_necessary_required: "Altijd actief",
      cat_preferences_name: "Voorkeuren",
      cat_preferences_desc: "Onthouden uw keuzes (taal, valuta, bezoekbron) om uw ervaring bij toekomstige bezoeken te personaliseren.",
      cat_statistics_name: "Statistieken",
      cat_statistics_desc: "Helpen ons begrijpen hoe bezoekers de site gebruiken (bekeken pagina's, sessieduur) om deze te verbeteren. Geanonimiseerde gegevens.",
      cat_marketing_name: "Marketing",
      cat_marketing_desc: "Meten de effectiviteit van onze advertentiecampagnes en leveren gepersonaliseerde advertenties op andere sites (Facebook, Instagram, TikTok, Pinterest, Google).",
      services_label: "Betrokken diensten"
    }
  };

  /* ============ Cookie helpers ============ */
  function setCookie(name, value, maxAgeDays, sameSite, domain) {
    var d = new Date();
    d.setTime(d.getTime() + maxAgeDays * 86400000);
    var c = name + "=" + encodeURIComponent(value) + "; expires=" + d.toUTCString() + "; path=/; SameSite=" + (sameSite || "Lax");
    if (domain) c += "; domain=" + domain;
    if (location.protocol === "https:") c += "; Secure";
    d.cookie = c;
    document.cookie = c;
  }
  function getCookie(name) {
    var m = document.cookie.match(new RegExp("(^|;\\s*)" + name + "=([^;]*)"));
    return m ? decodeURIComponent(m[2]) : null;
  }
  function delCookie(name) {
    document.cookie = name + "=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/";
  }

  /* ============ DOM helpers ============ */
  function el(tag, attrs, html) {
    var e = d.createElement(tag);
    if (attrs) for (var k in attrs) e.setAttribute(k, attrs[k]);
    if (html != null) e.innerHTML = html;
    return e;
  }
  function on(node, ev, fn) { node.addEventListener(ev, fn); }

  /* ============ Encode/decode consent state ============ */
  // Format: "n=1&p=0&s=0&m=1&t=1719420000&v=1"
  function encodeState(s) {
    return ["n=" + (s.necessary ? 1 : 0),
            "p=" + (s.preferences ? 1 : 0),
            "s=" + (s.statistics ? 1 : 0),
            "m=" + (s.marketing ? 1 : 0),
            "t=" + Math.floor(Date.now() / 1000),
            "v=1"].join("&");
  }
  function decodeState(str) {
    if (!str) return null;
    var s = { necessary: true, preferences: false, statistics: false, marketing: false, _ts: 0, _v: 0 };
    str.split("&").forEach(function (kv) {
      var p = kv.split("=");
      if (p[0] === "n") s.necessary = p[1] === "1";
      else if (p[0] === "p") s.preferences = p[1] === "1";
      else if (p[0] === "s") s.statistics = p[1] === "1";
      else if (p[0] === "m") s.marketing = p[1] === "1";
      else if (p[0] === "t") s._ts = parseInt(p[1], 10) || 0;
      else if (p[0] === "v") s._v = parseInt(p[1], 10) || 0;
    });
    return s;
  }

  /* ============ Main CMP class ============ */
  function CC() {
    this._config = null;
    this._t = null;          // current translation pack
    this._state = null;      // current consent state
    this._tab = "consent";   // current view
    this._mounted = false;
    this._dom = {};
  }
  CC.prototype = {

    init: function (cfg) {
      this._config = Object.assign({}, DEFAULTS, cfg || {});
      this._t = I18N[this._config.locale] || I18N[this._config.fallbackLocale];
      // Set Google Consent Mode v2 default IMMEDIATELY (idempotent — the snippet does this too)
      this._setConsentModeDefault();
      // Restore prior state
      var raw = getCookie(this._config.cookieName);
      this._state = decodeState(raw) || { necessary: true, preferences: false, statistics: false, marketing: false, _ts: 0, _v: 0 };
      // Mount UI when DOM is ready
      if (d.readyState === "loading") {
        d.addEventListener("DOMContentLoaded", this._mount.bind(this));
      } else {
        this._mount();
      }
    },

    _mount: function () {
      if (this._mounted) return;
      this._mounted = true;
      this._buildDOM();
      // If user has consented before → apply saved consent silently
      if (this._state._ts > 0) {
        this._applyConsent(false);
        if (this._config.showTrigger) this._showTrigger();
      } else {
        // Show bottom banner on first visit (less intrusive than modal)
        this._openBanner();
      }
      this._observeNewScripts();
    },

    /* ============ DOM construction ============ */
    _buildBanner: function () {
      var t = this._t;
      var cfg = this._config;
      var bar = el("div", { class: "cc-bottombar", role: "region", "aria-label": t.title });
      var inner = el("div", { class: "cc-bottombar-inner" });

      // LEFT — brand
      var brandCol = el("div", { class: "cc-bb-brand" });
      if (cfg.shopLogoUrl) {
        var img = el("img", { class: "cc-bb-brand-img", src: cfg.shopLogoUrl, alt: cfg.shopName || "Deco Arts", loading: "lazy", width: "120", height: "44" });
        brandCol.appendChild(img);
      } else {
        var brandLogo = el("div", { class: "cc-bb-brand-logo" });
        brandLogo.appendChild(el("div", { class: "cc-bb-brand-logo-icon", "aria-hidden": "true" }, this._iconCookie()));
        brandLogo.appendChild(el("div", { class: "cc-bb-brand-name" }, cfg.shopName || "Deco Arts"));
        brandCol.appendChild(brandLogo);
      }
      brandCol.appendChild(el("div", { class: "cc-bb-watermark" }, "<strong>Deco Arts</strong> &times; Linens Diffusion"));
      inner.appendChild(brandCol);

      // MIDDLE — content
      var contentCol = el("div", { class: "cc-bb-content" });
      contentCol.appendChild(el("h2", { class: "cc-bb-title" }, t.title));
      contentCol.appendChild(el("p", { class: "cc-bb-text" }, t.intro));
      contentCol.appendChild(el("p", { class: "cc-bb-text" }, t.learnMore.replace("{policy}", cfg.privacyPolicyUrl)));
      var detailsLink = el("button", { class: "cc-bb-details-link", "data-cc-action": "show-details", type: "button" });
      detailsLink.innerHTML = t.btn_show_details + " " + this._iconArrowRight();
      contentCol.appendChild(detailsLink);
      inner.appendChild(contentCol);

      // RIGHT — actions (CNIL parity: Reject + Accept primary)
      var actionsCol = el("div", { class: "cc-bb-actions" });
      var bbReject = el("button", { class: "cc-btn cc-btn-primary", "data-cc-action": "bb-reject", type: "button" }, t.btn_reject);
      var bbCustomize = el("button", { class: "cc-btn cc-btn-secondary", "data-cc-action": "bb-customize", type: "button" }, t.btn_customize);
      var bbAccept = el("button", { class: "cc-btn cc-btn-primary", "data-cc-action": "bb-accept", type: "button" }, t.btn_accept);
      actionsCol.appendChild(bbReject);
      actionsCol.appendChild(bbCustomize);
      actionsCol.appendChild(bbAccept);
      inner.appendChild(actionsCol);

      bar.appendChild(inner);
      return bar;
    },

    _buildDOM: function () {
      var t = this._t;
      var cfg = this._config;
      var root = el("div", { class: "cc-root", "data-cc-root": "" });

      // Bottom banner (consent view, shown first)
      var banner = this._buildBanner();
      root.appendChild(banner);

      // Backdrop (only visible when modal opens)
      var backdrop = el("div", { class: "cc-backdrop", "aria-hidden": "true" });
      root.appendChild(backdrop);

      // Modal container
      var modal = el("div", {
        class: "cc-modal",
        role: "dialog",
        "aria-modal": "true",
        "aria-labelledby": "cc-title",
        "aria-describedby": "cc-intro"
      });
      var card = el("div", { class: "cc-modal-card" });

      // Header
      var header = el("div", { class: "cc-header" });
      var headerRow = el("div", { class: "cc-header-row" });
      if (cfg.shopLogoUrl) {
        var headerImg = el("img", { class: "cc-header-logo-img", src: cfg.shopLogoUrl, alt: cfg.shopName || "Deco Arts", loading: "lazy" });
        headerRow.appendChild(headerImg);
      } else {
        var logo = el("div", { class: "cc-logo", "aria-hidden": "true" }, this._iconCookie());
        headerRow.appendChild(logo);
      }
      var titleBlock = el("div");
      titleBlock.appendChild(el("p", { class: "cc-subtitle" }, t.subtitle));
      titleBlock.appendChild(el("h2", { class: "cc-title", id: "cc-title" }, t.title));
      headerRow.appendChild(titleBlock);
      // Close button (X) — collapses modal back to bottom banner without saving consent
      var btnClose = el("button", {
        class: "cc-close-btn",
        type: "button",
        "data-cc-action": "close-modal",
        "aria-label": (t.btn_close || "Close") + " — " + (t.title || "Cookies")
      }, this._iconClose());
      headerRow.appendChild(btnClose);
      header.appendChild(headerRow);
      card.appendChild(header);

      // Tabs
      var tabs = el("div", { class: "cc-tabs", role: "tablist" });
      ["consent", "details", "about"].forEach(function (k) {
        var btn = el("button", { class: "cc-tab", "data-cc-tab": k, role: "tab", type: "button" }, t["tab_" + k]);
        tabs.appendChild(btn);
      });
      card.appendChild(tabs);

      // Body
      var body = el("div", { class: "cc-body" });
      // -- consent view
      var consentView = el("div", { "data-cc-view": "consent" });
      consentView.appendChild(el("p", { class: "cc-text", id: "cc-intro" }, t.intro));
      consentView.appendChild(el("p", { class: "cc-text" }, t.learnMore.replace("{policy}", cfg.privacyPolicyUrl)));
      body.appendChild(consentView);
      // -- details view (categories)
      var detailsView = el("div", { "data-cc-view": "details", class: "cc-hidden" });
      detailsView.appendChild(el("p", { class: "cc-text" }, t.detailsIntro));
      var cats = el("div", { class: "cc-categories" });
      this._renderCategories(cats);
      detailsView.appendChild(cats);
      body.appendChild(detailsView);
      // -- about view
      var aboutView = el("div", { "data-cc-view": "about", class: "cc-hidden" });
      aboutView.appendChild(el("h3", { class: "cc-text", style: "font-weight:600;color:var(--cc-brown-dark);font-size:15px;" }, t.aboutTitle));
      aboutView.appendChild(el("p", { class: "cc-text" }, t.aboutText.replace("{cookies}", cfg.cookiePolicyUrl)));
      body.appendChild(aboutView);
      card.appendChild(body);

      // Footer
      var footer = el("div", { class: "cc-footer" });
      var actions = el("div", { class: "cc-actions cc-actions-three" });
      // CNIL parity: Reject + Accept share the same visual weight (cc-btn-primary).
      // Customize / Save are the contextual secondary action (swap based on active tab).
      var btnReject = el("button", { class: "cc-btn cc-btn-primary", "data-cc-action": "reject", type: "button" }, t.btn_reject);
      var btnCustomize = el("button", { class: "cc-btn cc-btn-secondary", "data-cc-action": "customize", type: "button" }, t.btn_customize);
      var btnAccept = el("button", { class: "cc-btn cc-btn-primary", "data-cc-action": "accept", type: "button" }, t.btn_accept);
      var btnSave = el("button", { class: "cc-btn cc-btn-secondary cc-hidden", "data-cc-action": "save", type: "button" }, t.btn_save);
      // Order: Reject / [Customize|Save] / Accept — Save and Customize share the middle slot
      actions.appendChild(btnReject);
      actions.appendChild(btnCustomize);
      actions.appendChild(btnSave);
      actions.appendChild(btnAccept);
      footer.appendChild(actions);
      footer.appendChild(el("p", { class: "cc-meta" }, t.meta));
      footer.appendChild(el("p", { class: "cc-modal-watermark" }, "<strong>Deco Arts</strong> &times; Linens Diffusion"));
      card.appendChild(footer);

      modal.appendChild(card);
      root.appendChild(modal);

      // Floating trigger
      if (cfg.showTrigger) {
        var trigger = el("button", {
          class: "cc-trigger cc-hidden",
          "data-cc-trigger": "",
          "aria-label": t.trigger_aria,
          type: "button"
        }, this._iconShield() + '<span class="cc-trigger-label">' + t.trigger_label + '</span>');
        root.appendChild(trigger);
        this._dom.trigger = trigger;
        on(trigger, "click", this._openModal.bind(this, "details"));
      }

      d.body.appendChild(root);

      // Cache DOM refs
      this._dom.root = root;
      this._dom.banner = banner;
      this._dom.backdrop = backdrop;
      this._dom.modal = modal;
      this._dom.card = card;
      this._dom.tabs = tabs;
      this._dom.body = body;
      this._dom.btnAccept = btnAccept;
      this._dom.btnReject = btnReject;
      this._dom.btnCustomize = btnCustomize;
      this._dom.btnSave = btnSave;

      // Wire events
      this._wireEvents();
      this._setActiveTab(this._tab);
    },

    _renderCategories: function (container) {
      var self = this;
      var t = this._t;
      var state = this._state;
      // Count = number of distinct cookies/services per category (Cookiebot-style badge)
      var cats = [
        { key: "necessary",   count: 9,  required: true,  services: ["_shopify_essential", "localization", "cart", "secure_customer_sig", "cc_decoarts_v1", "wpm-ri-*", "ri-*", "_shs_state", "consentHeader"] },
        { key: "preferences", count: 5,  required: false, services: ["_shopify_y", "lastExternalReferrer", "lastExternalReferrerTime", "_landing_page", "_orig_referrer"] },
        { key: "statistics",  count: 6,  required: false, services: ["Google Analytics 4", "_ga", "_ga_96PH7XDFRZ", "_shopify_s", "_shopify_analytics", "Bugsnag"] },
        { key: "marketing",   count: 15, required: false, services: ["Meta Pixel", "_fbp", "TikTok Pixel", "_ttp", "ttcsid_*", "ttcsid", "tt_sessionId", "tt_s_pixel_session_index", "tt_appInfo_v2", "Pinterest Tag", "_pin_unauth", "_gcl_au", "_gcl_ls", "_shopify_marketing", "da_meta_tracking_v1"] }
      ];
      cats.forEach(function (c) {
        var wrap = el("div", { class: "cc-category", "data-cc-cat": c.key });
        // Header row
        var header = el("div", { class: "cc-cat-header", role: "button", tabindex: "0", "aria-expanded": "false" });
        var left = el("div", { class: "cc-cat-toggle-wrap" });
        // Toggle
        var label = el("label", { class: "cc-switch", "aria-label": t["cat_" + c.key + "_name"] });
        var input = el("input", { type: "checkbox", "data-cc-toggle": c.key });
        if (c.required) input.disabled = true;
        if (c.required || state[c.key]) input.checked = true;
        label.appendChild(input);
        label.appendChild(el("span", { class: "cc-switch-slider" }));
        left.appendChild(label);
        var nameWrap = el("div");
        var nameRow = el("div");
        var nameSpan = el("span", { class: "cc-cat-name" });
        nameSpan.appendChild(document.createTextNode(t["cat_" + c.key + "_name"]));
        if (c.count) nameSpan.appendChild(el("span", { class: "cc-cat-count", "aria-label": c.count + " cookies" }, String(c.count)));
        nameRow.appendChild(nameSpan);
        if (c.required) nameRow.appendChild(el("span", { class: "cc-cat-required" }, t.cat_necessary_required));
        nameWrap.appendChild(nameRow);
        left.appendChild(nameWrap);
        header.appendChild(left);
        // Chevron
        header.appendChild(el("span", { class: "cc-cat-chevron", "aria-hidden": "true" }, self._iconChevron()));
        wrap.appendChild(header);
        // Body
        var body = el("div", { class: "cc-cat-body" });
        var content = el("div", { class: "cc-cat-content" });
        content.appendChild(el("p", null, t["cat_" + c.key + "_desc"]));
        if (c.services && c.services.length) {
          var servicesWrap = el("div", { class: "cc-cat-services" });
          servicesWrap.setAttribute("aria-label", t.services_label);
          c.services.forEach(function (s) {
            servicesWrap.appendChild(el("span", { class: "cc-service-chip" }, s));
          });
          content.appendChild(servicesWrap);
        }
        body.appendChild(content);
        wrap.appendChild(body);
        // Stop click propagation on label so toggle works without expanding
        on(label, "click", function (e) { e.stopPropagation(); });
        container.appendChild(wrap);
      });
    },

    /* ============ Events ============ */
    _wireEvents: function () {
      var self = this;
      // Tabs
      this._dom.tabs.querySelectorAll(".cc-tab").forEach(function (b) {
        on(b, "click", function () { self._setActiveTab(b.getAttribute("data-cc-tab")); });
      });
      // Modal buttons (in details/about views)
      on(this._dom.btnAccept, "click", function () { self.acceptAll(); });
      on(this._dom.btnReject, "click", function () { self.rejectAll(); });
      on(this._dom.btnCustomize, "click", function () { self._setActiveTab("details"); });
      on(this._dom.btnSave, "click", function () { self.saveSelection(); });
      // Close (X) button in modal header — collapses to banner (no consent saved)
      var btnCloseInDom = this._dom.modal.querySelector('[data-cc-action="close-modal"]');
      if (btnCloseInDom) on(btnCloseInDom, "click", function () { self._collapseToBanner(); });
      // Bottom banner buttons
      this._dom.banner.querySelectorAll('[data-cc-action]').forEach(function (b) {
        on(b, "click", function () {
          var action = b.getAttribute("data-cc-action");
          if (action === "bb-accept") self.acceptAll();
          else if (action === "bb-reject") self.rejectAll();
          else if (action === "bb-customize" || action === "show-details") self._openModal("details");
        });
      });
      // Categories accordion (open by default, click to collapse)
      this._dom.body.querySelectorAll(".cc-category").forEach(function (cat) {
        var header = cat.querySelector(".cc-cat-header");
        // Initial state: open (aria-expanded=true)
        header.setAttribute("aria-expanded", "true");
        on(header, "click", function () {
          cat.classList.toggle("cc-collapsed");
          header.setAttribute("aria-expanded", !cat.classList.contains("cc-collapsed") ? "true" : "false");
        });
        on(header, "keydown", function (e) {
          if (e.key === "Enter" || e.key === " ") { e.preventDefault(); header.click(); }
        });
      });
      // ESC closes modal IF user has prior consent (otherwise it's blocking)
      on(d, "keydown", function (e) {
        if (e.key === "Escape" && self._state._ts > 0) self._close();
      });
    },

    _setActiveTab: function (k) {
      this._tab = k;
      // Tabs visual state
      this._dom.tabs.querySelectorAll(".cc-tab").forEach(function (b) {
        b.classList.toggle("cc-active", b.getAttribute("data-cc-tab") === k);
        b.setAttribute("aria-selected", b.getAttribute("data-cc-tab") === k ? "true" : "false");
      });
      // Views visibility
      this._dom.body.querySelectorAll("[data-cc-view]").forEach(function (v) {
        v.classList.toggle("cc-hidden", v.getAttribute("data-cc-view") !== k);
      });
      // Buttons swap: details view → show Save instead of Customize
      if (k === "details") {
        this._dom.btnCustomize.classList.add("cc-hidden");
        this._dom.btnSave.classList.remove("cc-hidden");
      } else {
        this._dom.btnCustomize.classList.remove("cc-hidden");
        this._dom.btnSave.classList.add("cc-hidden");
      }
    },

    /* ============ Public actions ============ */
    _openBanner: function () {
      // Bottom banner mode — page remains interactive, no backdrop
      this._dom.banner.classList.add("cc-visible");
      d.body.classList.add("cc-bottombar-active");
      // Hide trigger while banner is open
      if (this._dom.trigger) this._dom.trigger.classList.add("cc-hidden");
    },
    _openModal: function (tab) {
      // Centered modal — backdrop is decorative only (pointer-events: none),
      // body scroll is NOT locked. User can keep navigating the site.
      // If they navigate to another page without consenting, the banner
      // reappears on the next page (because the cookie hasn't been saved).
      this._setActiveTab(tab || "details");
      this._dom.backdrop.classList.add("cc-visible");
      this._dom.modal.classList.add("cc-visible");
      // Hide banner — modal replaces it visually
      this._dom.banner.classList.remove("cc-visible");
      d.body.classList.remove("cc-bottombar-active");
      // NOTE: body.style.overflow intentionally NOT set — page must remain interactive
      if (this._dom.trigger) this._dom.trigger.classList.add("cc-hidden");
    },
    _close: function () {
      this._dom.backdrop.classList.remove("cc-visible");
      this._dom.modal.classList.remove("cc-visible");
      this._dom.banner.classList.remove("cc-visible");
      d.body.classList.remove("cc-bottombar-active");
      d.body.style.overflow = "";
      if (this._config.showTrigger) this._showTrigger();
    },
    _showTrigger: function () {
      if (this._dom.trigger) this._dom.trigger.classList.remove("cc-hidden");
    },

    show: function () { this._openBanner(); },
    showSettings: function () { this._openModal("details"); },

    acceptAll: function () {
      this._state.necessary = true;
      this._state.preferences = true;
      this._state.statistics = true;
      this._state.marketing = true;
      this._persist();
      this._applyConsent(true);
      this._close();
    },

    rejectAll: function () {
      this._state.necessary = true;
      this._state.preferences = false;
      this._state.statistics = false;
      this._state.marketing = false;
      this._persist();
      this._applyConsent(true);
      this._close();
    },

    saveSelection: function () {
      var inputs = this._dom.body.querySelectorAll("[data-cc-toggle]");
      var self = this;
      inputs.forEach(function (i) {
        var k = i.getAttribute("data-cc-toggle");
        self._state[k] = !!i.checked;
      });
      this._state.necessary = true;
      this._persist();
      this._applyConsent(true);
      this._close();
    },

    _persist: function () {
      this._state._ts = Math.floor(Date.now() / 1000);
      this._state._v = 1;
      setCookie(this._config.cookieName, encodeState(this._state), this._config.cookieMaxAgeDays, this._config.cookieSameSite, this._config.cookieDomain);
    },

    /* ============ Bridge: Google Consent Mode v2 ============ */
    _setConsentModeDefault: function () {
      w.dataLayer = w.dataLayer || [];
      function gtag() { w.dataLayer.push(arguments); }
      w.gtag = w.gtag || gtag;
      // Only set default if it hasn't been set yet — we provide it again as safety net
      gtag("consent", "default", {
        ad_storage: "denied",
        ad_user_data: "denied",
        ad_personalization: "denied",
        analytics_storage: "denied",
        functionality_storage: "granted",
        security_storage: "granted",
        personalization_storage: "denied",
        wait_for_update: 500
      });
    },

    _updateConsentMode: function () {
      w.dataLayer = w.dataLayer || [];
      function gtag() { w.dataLayer.push(arguments); }
      var s = this._state;
      gtag("consent", "update", {
        ad_storage: s.marketing ? "granted" : "denied",
        ad_user_data: s.marketing ? "granted" : "denied",
        ad_personalization: s.marketing ? "granted" : "denied",
        analytics_storage: s.statistics ? "granted" : "denied",
        functionality_storage: s.preferences ? "granted" : "denied",
        personalization_storage: s.preferences ? "granted" : "denied",
        security_storage: "granted"
      });
    },

    /* ============ Bridge: Shopify Customer Privacy API ============ */
    _updateShopifyConsent: function () {
      var s = this._state;
      try {
        if (w.Shopify && w.Shopify.customerPrivacy && typeof w.Shopify.customerPrivacy.setTrackingConsent === "function") {
          w.Shopify.customerPrivacy.setTrackingConsent({
            analytics: !!s.statistics,
            marketing: !!s.marketing,
            preferences: !!s.preferences,
            sale_of_data: !!s.marketing
          }, function () { /* callback noop */ });
        }
      } catch (err) {
        // silent — Shopify Customer Privacy not always ready early
      }
    },

    /* ============ Auto-blocking pattern ============ */
    /* <script type="text/plain" data-cc="marketing" src="...">
       <script type="text/plain" data-cc="statistics">inline code</script> */
    _unblockScripts: function () {
      var s = this._state;
      var scripts = d.querySelectorAll('script[type="text/plain"][data-cc]');
      var enabled = { necessary: true, preferences: !!s.preferences, statistics: !!s.statistics, marketing: !!s.marketing };
      scripts.forEach(function (orig) {
        var cat = orig.getAttribute("data-cc");
        if (!enabled[cat]) return;
        var nu = d.createElement("script");
        // Copy attrs
        for (var i = 0; i < orig.attributes.length; i++) {
          var a = orig.attributes[i];
          if (a.name === "type" || a.name === "data-cc") continue;
          nu.setAttribute(a.name, a.value);
        }
        nu.setAttribute("type", "text/javascript");
        if (orig.innerHTML) nu.innerHTML = orig.innerHTML;
        orig.parentNode.replaceChild(nu, orig);
      });
      // Also unblock <iframe data-cc-src="...">
      var iframes = d.querySelectorAll("iframe[data-cc-src][data-cc]");
      iframes.forEach(function (f) {
        var cat = f.getAttribute("data-cc");
        if (!enabled[cat]) return;
        f.setAttribute("src", f.getAttribute("data-cc-src"));
        f.removeAttribute("data-cc-src");
      });
    },

    /* Watch DOM for new <script type="text/plain"> injected after init */
    _observeNewScripts: function () {
      if (!w.MutationObserver) return;
      var self = this;
      var obs = new MutationObserver(function (muts) {
        var hasNew = false;
        muts.forEach(function (m) {
          for (var i = 0; i < m.addedNodes.length; i++) {
            var n = m.addedNodes[i];
            if (n.nodeType === 1 && n.tagName === "SCRIPT" && n.type === "text/plain" && n.hasAttribute("data-cc")) {
              hasNew = true;
              break;
            }
          }
        });
        if (hasNew) self._unblockScripts();
      });
      obs.observe(d.documentElement, { childList: true, subtree: true });
    },

    /* ============ Apply consent (orchestrator) ============ */
    _applyConsent: function (emit) {
      this._updateConsentMode();
      this._updateShopifyConsent();
      this._unblockScripts();
      // Custom event for partner integrations
      try {
        w.dispatchEvent(new CustomEvent("cc:consent-updated", {
          detail: {
            necessary: !!this._state.necessary,
            preferences: !!this._state.preferences,
            statistics: !!this._state.statistics,
            marketing: !!this._state.marketing,
            timestamp: this._state._ts
          }
        }));
      } catch (e) { /* noop */ }
    },

    /* ============ Public read API ============ */
    hasConsent: function (cat) {
      if (!this._state) return false;
      return !!this._state[cat];
    },
    getState: function () {
      return Object.assign({}, this._state);
    },
    reset: function () {
      delCookie(this._config.cookieName);
      location.reload();
    },

    /* ============ Icons ============ */
    _iconCookie: function () {
      return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2a10 10 0 1 0 10 10 4 4 0 0 1-5-5 4 4 0 0 1-5-5z"/><circle cx="9" cy="9" r="0.5" fill="currentColor"/><circle cx="14" cy="14" r="0.5" fill="currentColor"/><circle cx="9" cy="15" r="0.5" fill="currentColor"/></svg>';
    },
    _iconShield: function () {
      return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><circle cx="12" cy="11" r="2"/><path d="M12 13v3"/></svg>';
    },
    _iconChevron: function () {
      return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"/></svg>';
    },
    _iconArrowRight: function () {
      return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" style="display:inline-block;vertical-align:middle"><polyline points="9 18 15 12 9 6"/></svg>';
    },
    _iconClose: function () {
      return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>';
    },
    _collapseToBanner: function () {
      // Close modal but reopen banner — user hasn't consented yet, banner persists
      this._dom.backdrop.classList.remove("cc-visible");
      this._dom.modal.classList.remove("cc-visible");
      d.body.style.overflow = "";
      // If user has prior consent, just close everything (no banner needed)
      if (this._state._ts > 0) {
        if (this._config.showTrigger) this._showTrigger();
      } else {
        // Reopen banner
        this._openBanner();
      }
    }
  };

  /* ============ Expose ============ */
  w.DecoArtsCC = w.DecoArtsCC || new CC();

})(window, document);
